import { useMutation } from '@tanstack/react-query';
import { updatePassword } from '@/lib/api/settings';
import type { PasswordFormData } from '@/features/settings/validations/password';
import { queryClient } from '@/queries';
import { QUERY_KEYS } from '@/lib/constants';

export const usePassword = () => {
    const { mutateAsync, isPending } = useMutation({
        mutationFn: (data: PasswordFormData) => updatePassword(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
        },
    });

    return { mutateAsync, isPending };
};
